export default __webpack_public_path__ + "static/media/coleta-mujer-rubio.74618a0a.png";